module.exports = __webpack_public_path__ + "img/typing-loading.gif";